import { equals2 } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { ControllerNS } from "../../Controller/ControllerNS.js";
import { VONS } from "../../VO/VONS.js";
import { makeActiveColor } from "../../../../Util/color.js";
export class TargetPointView {
  constructor({ document, point_size_controller }) {
    this._point_g_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "g"
    );
    this._point_g_el.setAttributeNS(null, "transform", "translate(0 0)");
    this._point_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "point";
    this._background_circle_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "circle"
    );
    this._background_circle_el.setAttributeNS(null, "cx", "0");
    this._background_circle_el.setAttributeNS(null, "cy", "0");
    this._background_circle_el.setAttributeNS(null, "r", "0");
    this._background_circle_el.setAttributeNS(null, "fill", "transparent");
    this._background_circle_el.setAttributeNS(null, "stroke", "none");
    this._background_circle_el.style.cursor = "grabbing";
    this._point_g_el.appendChild(this._background_circle_el);
    this._display_circle_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "circle"
    );
    this._display_circle_el.setAttributeNS(null, "cx", "0");
    this._display_circle_el.setAttributeNS(null, "cy", "0");
    this._display_circle_el.setAttributeNS(null, "r", "0");
    this._display_circle_el.setAttributeNS(null, "fill", "#FFFFFF");
    this._display_circle_el.setAttributeNS(null, "stroke", "#B1B1B1");
    this._display_circle_el.setAttributeNS(null, "stroke-width", "1");
    this._display_circle_el.setAttributeNS(
      null,
      "vector-effect",
      "non-scaling-stroke"
    );
    this._display_circle_el.style.cursor = "grabbing";
    this._point_g_el.appendChild(this._display_circle_el);
    point_size_controller.subscribe((point_size_vo) =>
      this._observePointSizeController(point_size_vo)
    );
  }
  setPosition({ x, y }) {
    this._point_g_el.setAttributeNS(null, "transform", `translate(${x} ${y})`);
  }
  show() {
    this._point_g_el.style.display = "";
  }
  hide() {
    this._point_g_el.style.display = "none";
  }
  select() {
    this._display_circle_el.setAttributeNS(null, "fill", makeActiveColor());
    this._display_circle_el.setAttributeNS(null, "stroke", "#FFFFFF");
    this._display_circle_el.setAttributeNS(null, "transform", "scale(1.5 1.5)");
    this._point_g_el.dataset.is_selected = "true";
  }
  unselect() {
    this._display_circle_el.setAttributeNS(null, "fill", "#FFFFFF");
    this._display_circle_el.setAttributeNS(null, "stroke", "#B1B1B1");
    this._display_circle_el.removeAttributeNS(null, "transform");
    this._point_g_el.dataset.is_selected = "false";
  }
  getIsSelected() {
    return equals2("true")(this._point_g_el.dataset.is_selected);
  }
  getEl() {
    return this._point_g_el;
  }
  _observePointSizeController({ outer_size, inner_size }) {
    this._background_circle_el.setAttributeNS(null, "r", `${outer_size / 2}`);
    this._display_circle_el.setAttributeNS(null, "r", `${inner_size / 2}`);
  }
}
